<template>
    <modal :name="modalName" width="100%" height="auto">
        <div class="p-3">
            <div class="mt-3 text-center">
                <h3 id="modal-headline">
                    {{ $t("Number of customers") }}
                </h3>
                <div class="mt-2">
                    <p>
                        {{ $t("Please update the number of customers at your table.") }}"
                    </p>
                </div>
            </div>

            <div class="mt-3 text-center">
                <div class="btn-qty-sm d-flex justify-content-center">
                    <button :disabled="coversNo <= 1" class="btn minus1" v-on:click="coversNo -= 1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 13H5v-2h14v2z" />
                        </svg>
                    </button>
                    <input class="quantity" min="0" v-model.number="coversNo" type="number">
                    <button class="btn add1" v-on:click="coversNo += 1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <hr>

        <div class="flex justify-content-center border-solid mt-4 pt-1 mb-4">
            <button class="btn btn-reset mr-2" v-on:click="$modal.hide(modalName)">{{ $t("Cancel") }}</button>
            <button class="btn btn-primary ml-2" v-on:click="$emit('apply', coversNo)">{{ $t("Apply") }}</button>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['value', 'modalName'],
    data() {
        return {
            coversNo: this.value,
        }
    },
    watch: {
        coversNo() {
            this.$emit('input', this.coversNo)
        }
    }
}
</script>
